export const marketingChannelOptions = [
  'In-App Events',
  'Existing Platforms',
  'Engineering as Marketing',
  'Affiliate Programs',
  'Affiliate Programs - US',
  'Business Development (BD)',
  'Community Building',
  'Content Marketing',
  'Email Marketing',
  'Engineering as Marketing (USA)',
  'Influencers',
  'Offline Ads',
  'Offline Events',
  'Publicity (PR)',
  'Sales',
  'Search Engine Marketing (SEM)',
  'Search Engine Optimization (SEO)',
  'Social and Display Ads',
  'Speaking Engagements',
  'Targeting Blogs',
  'Trade Shows',
  'Unconventional PR',
  'Viral Marketing',
];
